import React, {Component} from "react";
import {Link} from "react-router-dom";
import {observer} from "mobx-react";
import {mesAutobind} from "@posco/posco-shared";


@mesAutobind
@observer
class MenuFavorList extends Component {
  render() {
    return (
      <div style={{display: "visible"}}
           className={`
           ${this.props.menuStatue.bookmark ? "shown menuBookmark" : "hidden menuBookmark"}
           ${this.props.favorMenuList.length && "actArrow"}
           `}
      >
      <span onClick={() => {
        this.props.menuStatueSet({...this.props.menuStatue, bookmark: !this.props.menuStatue.bookmark});
      }}>즐겨찾기</span>
        <ul>
          {this.props.favorMenuList.map(props =>
            <li key={props.pattMenuId}
                className={this.props.activePattMenuIdArray.includes(props.pattMenuId) ? "thisPage" : null}
            >
              {/* pgmUrl 없으면 클릭, 마우스표시 안되게 처리*/}
              {props.pgmUrl ?
                <Link
                  key={props.pattMenuId}
                  onClick={this.props.adding}
                  pattmenuid={props.pattMenuId}
                  pattmenuid1={props.pattMenuId1}
                  to={props.pgmUrl || ""}
                  pgmurl={props.pgmUrl || ""}
                  pageid={props.pageId}
                  style={{whiteSpace: "pre"}}
                >
                  {props.menuNm}
                </Link>
                :
                <a style={{whiteSpace: "pre", cursor: "default"}}>{props.menuNm}</a>
              }
            </li>
          )}
        </ul>
      </div>
    );
  }
}

export default MenuFavorList;
